import { trackAnalyticsEvent } from '@jsmdg/tracking';

async function trackEmailClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'TextClick',
        label: 'B2B_Mail',
    });
}

async function trackPhoneNumberClicked(label: string): Promise<void> {
    if (label) {
        await window.yieldToMainThread();
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'TextClick',
            label,
        });
    }
}

export { trackEmailClicked, trackPhoneNumberClicked };
